import React from 'react';

// Basic styling (can be moved to a CSS file later)
const styles = {
  container: {
    border: '1px solid #eee',
    borderRadius: '8px',
    padding: '1rem',
    marginBottom: '1rem',
    backgroundColor: '#f9f9f9',
  },
  title: {
    fontSize: '1.3rem',
    color: '#333',
    marginBottom: '0.8rem',
    borderBottom: '1px solid #ddd',
    paddingBottom: '0.5rem',
  },
  detailItem: {
    marginBottom: '0.5rem',
    fontSize: '1rem',
  },
  label: {
    fontWeight: 'bold',
    marginRight: '0.5rem',
    color: '#555',
  }
};

const QRScanDetailAlat = ({ alatData }) => {
  if (!alatData) {
    return <div style={styles.container}>Data alat tidak tersedia.</div>;
  }

  // Determine display text for type
  const jenisText = alatData.type === 'instrumen' ? 'Instrumen' : 'Alat Gelas';

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Detail Alat</h3>
      <div style={styles.detailItem}>
        <span style={styles.label}>Nama:</span> {alatData.nama || 'N/A'}
      </div>
      <div style={styles.detailItem}>
        <span style={styles.label}>Jenis:</span> {jenisText}
      </div>
      {/* Add other relevant details if they exist in your data structure */}
      {alatData.merk && (
        <div style={styles.detailItem}>
          <span style={styles.label}>Merk:</span> {alatData.merk}
        </div>
      )}
      {alatData.lokasi && (
        <div style={styles.detailItem}>
          <span style={styles.label}>Lokasi:</span> {alatData.lokasi}
        </div>
      )}
       {alatData.deskripsi && (
        <div style={styles.detailItem}>
          <span style={styles.label}>Deskripsi:</span> {alatData.deskripsi}
        </div>
      )}
       {alatData.statusAlat && (
        <div style={styles.detailItem}>
          <span style={styles.label}>Status Saat Ini:</span> {alatData.statusAlat}
        </div>
      )}
      {/* Add more fields as needed */}
    </div>
  );
};

export default QRScanDetailAlat;
